module.exports = require('./readable').PassThrough



// WEBPACK FOOTER //
// (webpack)/~/readable-stream/passthrough.js